import Vuex from 'vuex';
import Vue from 'vue';
import app from './modules/app';
import areas from './modules/ski/areas';
import transportation from './modules/transportation';
import itinerary from './modules/itinerary';
import nav from './modules/nav';
import skistar from './modules/ski/skistar';
import restech from './modules/ski/restech';
import snackbar from './modules/snackbar';
import twenty from './modules/twenty';
import skipass from './modules/ski/skipass';
import nonDynamicTransport from './modules/non-dynamic-transport';
import skischool from './modules/ski/school';
import skirental from './modules/ski/rental';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    app,
    areas,
    transportation,
    itinerary,
    nav,
    skistar,
    restech,
    snackbar,
    twenty,
    skipass,
    nonDynamicTransport,
    skischool,
    skirental,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js